// ModalNuevaMarca.js
import React, { useState } from "react";
import { toast } from "react-toastify";
import { ApiService } from "../ApiService";

export const ModalNuevaMarca = ({ isOpen = true, onClose, onBrandAdded, selectedSucursal }) => {
	const [nombreMarca, setNombreMarca] = useState("");
	const [descripcionMarca, setDescripcionMarca] = useState("");
	const [imagenMarca, setImagenMarca] = useState(null);
	const [imagenPreview, setImagenPreview] = useState(null);
	const [uploadState, setUploadState] = useState(false);


	const [nombreMarcaError, setNombreMarcaError] = useState(false);
	const [descripcionMarcaError, setDescripcionMarcaError] = useState(false);
	const [imagenMarcaError, setImagenMarcaError] = useState(false);

	if (!isOpen) return null;

	const handleImageChange = (e) => {
		const file = e.target.files[0];
		if (file) {
			const allowedExtensions = ["image/jpeg", "image/jpg", "image/png"];
			if (!allowedExtensions.includes(file.type)) {
				setImagenMarcaError(true);
				toast.error("El formato de la imagen debe ser JPG, JPEG o PNG");
				setImagenMarca(null);
				setImagenPreview(null);
			} else {
				setImagenMarcaError(false);
				setImagenMarca(file);
				setImagenPreview(URL.createObjectURL(file));
			}
		}
	};

	const handleRemoveImage = () => {
		setImagenMarca(null);
		setImagenPreview(null);
	};

	const uploadImage = async (imageFile, token) => {
		const formData = new FormData();
		// formData.append('type', 'document_brand');
		formData.append("file", imageFile);

		try {
			const url = `api/upload/file`;
			const options = {
				method: "POST",
				body: formData, // `ApiService` ya maneja los headers, no es necesario agregar `Authorization`
			};

			const response = await ApiService.fetchData(url, options, false);

			if (response.url) return response.url;

			toast.error(response.message || "No se pudo subir la imagen");
			return null;
		} catch (error) {
			toast.error("Error al conectar con la API de subida de imágenes");
			return null;
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();

		let hasError = false;

		if (!nombreMarca.trim()) {
			setNombreMarcaError(true);
			toast.error("El nombre de la marca es obligatorio");
			hasError = true;
		} else {
			setNombreMarcaError(false);
		}

		// Si la descripción está vacía, asignar "Sin descripción"
		const descripcionFinal = descripcionMarca.trim() || "Sin descripción";

		// Dado que ya no es obligatorio tener descripción distinta a vacía,
		// removemos la lógica del error en descripción.
		setDescripcionMarcaError(false);

		// if (!imagenMarca) {
		// 	setImagenMarcaError(true);
		// 	toast.error("La imagen de la marca es obligatoria");
		// 	hasError = true;
		// } else {
		// 	setImagenMarcaError(false);
		// }

		if (hasError) {
			return;
		}

		setUploadState(true);
		const token = localStorage.getItem("token");
		if (!token) {
			toast.error("Token no disponible");
			return;
		}

		const imageFile = imagenMarca;
		const nombre = nombreMarca;

		// Cerramos el modal inmediatamente

		let imagenURL = "";
		if (imageFile) {
			imagenURL = await uploadImage(imageFile, token);
			if (!imagenURL) {
				return;
			}
		}

		const payload = {
			name: nombre,
			description: descripcionFinal,
			imgUrl: imagenURL,
		};

		try {
			const url = `api/company/brand/insert?key_branch=${selectedSucursal}`;
			const options = {
				method: "POST",
				body: JSON.stringify(payload),
			};

			const response = await ApiService.fetchData(url, options);

			if (response) {
				onBrandAdded("brand", {
					key_brand: response?.key_brand ?? 0,
					name: nombreMarca
				});

				toast.success("Marca agregada con éxito");
				onClose();

				setImagenMarca(null);
				setNombreMarca("");
				setDescripcionMarca("");
				setImagenPreview(null);
			}
		} catch (error) {
			toast.error("Error al conectar con la API");
		} finally {
			setUploadState(false);
		}
	};

	return (
		<div className="modal-overlay-old">
			<div className="modal-container-old">
				<div className="modal-header-old">
					<h2 className="modal-title">Nueva Marca</h2>
					<button className="close-modal-btn" onClick={onClose}>
						✖
					</button>
				</div>

				<form
					onSubmit={(e) => e.preventDefault()} // Evita submit nativo
					onKeyDown={(e) => {
						if (e.key === "Enter") {
							e.preventDefault(); // Siempre previene el comportamiento por defecto
							document.getElementById("guardarMarcaBtn")?.click(); // Simula clic en Guardar
						}
					}}
				>
					<div className="modal-body">
						<div className="form-group">
							<label htmlFor="marcaNombre">
								Nombre de la marca<span className="obligate">*</span>
							</label>
							<input
								type="text"
								id="marcaNombre"
								name="marcaNombre"
								placeholder="Ingrese el nombre de la marca"
								className={`modal-input-old ${nombreMarcaError ? "input-error" : ""}`}
								value={nombreMarca}
								onChange={(e) => setNombreMarca(e.target.value)}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="marcaDescripcion">Descripción:</label>
							<input
								id="marcaDescripcion"
								name="marcaDescripcion"
								placeholder="Ingrese una descripción"
								className={`modal-input-old ${descripcionMarcaError ? "input-error" : ""}`}
								value={descripcionMarca}
								onChange={(e) => setDescripcionMarca(e.target.value)}
							/>
						</div>

						<div className="form-group">
							<label htmlFor="marcaImagen">
								Imagen de la marca<span className="obligate">*</span>
							</label>
							<div className="image-upload-container">
								<input
									type="file"
									id="marcaImagen"
									name="marcaImagen"
									accept="image/jpeg,image/jpg,image/png"
									onChange={handleImageChange}
									style={{ display: "none" }}
								/>
								<button
									type="button"
									className={`upload-button ${imagenMarca ? "disabled-button" : ""}`}
									onClick={() => document.getElementById("marcaImagen").click()}
									disabled={!!imagenMarca}
								>
									Subir imagen
								</button>
								{imagenPreview && (
									<div className="image-container-modal">
										<img src={imagenPreview} alt="Vista previa" className="image-preview-brand" />
										<button className="remove-image-btn" onClick={handleRemoveImage}>
											✖
										</button>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="modal-footer">
						<button type="button" className="cancel-button-product" onClick={onClose}>
							Cancelar
						</button>
						<button
							id="guardarMarcaBtn"
							type="button"
							className="save-button"
							onClick={handleSubmit}
							disabled={uploadState}
							style={{ opacity: uploadState ? '0.7' : '1' }}
						>
							{uploadState ? 'Subiendo...' : 'Guardar'}
						</button>
					</div>
				</form>

			</div>
		</div>
	);
};
